/* eslint-disable no-use-before-define */
import React from 'react';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import DataTableActionMenu from '../Elements/DataTable/DataTableActionMenu';
import LongText from '../Elements/LongText';
import ErrorMessage from '../Elements/ErrorMessage';
import JsxHelper from '../Helpers/JsxHelper';

export default class TpSurveyItem
{
  constructor (item)
  {
    if (item === undefined)
    {
      this.TpSurveyId = '';
      this.ThirdPartySurveyName = '';
      this.ThirdPartySurveyId = '';
      this.IsUninvoiceable = '';
      this.TpClientLinkId = '';
      this.SurveyType = '';
      this.ThirdPartySource = '';
      this.IsActivated = '';
      this.CreatedBy = '';
      this.CreatedOnUtc = '';
      this.ModifiedBy = '';
      this.ModifiedOnUtc = '';
      this.IsActivatedText = '';
      return;
    }
    this.TpSurveyId = item.tpSurveyId;
    this.ThirdPartySurveyName = item.thirdPartySurveyName;
    this.ThirdPartySurveyId = item.thirdPartySurveyId;
    this.IsUninvoiceable = item.isUninvoiceable;
    this.TpClientLinkId = item.tpClientLinkId;
    this.SurveyType = item.surveyType;
    this.ThirdPartySource = item.thirdPartySource;
    this.IsActivated = item.isActivated;
    this.CreatedBy = item.createdBy;
    this.CreatedOnUtc = item.createdOnUtc;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedByUserName = item.modifiedByUserName;
    this.CreatedByUserName = item.createdByUserName;
    this.ModifiedOnUtc = item.modifiedOnUtc;
    this.IsActivatedText = item.isActivated == true ? 'Yes' : 'No';
    this.IsInvoiceable = item.isUninvoiceable !== true;
  }

  static NameOfTheIdField ()
  {
    return 'TpSurveyId';
  }

  static MoneyFields = [];

  static Currency ()
  {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary ()
  {
    return '';
  }

  static DateFields = [ 'CreatedOnUtc', 'ModifiedOnUtc' ];
  static BoolFields = [ 'IsUninvoiceable' ];

  static nameOfTheItemDetailList (item)
  {
    return `${item.ThirdPartySurveyName} (${item.TpSurveyId})`;
  }

  static FieldsToShowInDataTable ()
  {
    // prettier-ignore
    return [
      {
        label: 'Id',
        orderById: 'TpSurveyId',
        data: 'TpSurveyId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      {
        label: 'Name',
        orderById: 'ThirdPartySurveyName',
        data: (item) => (
          <LongText
            text={item.ThirdPartySurveyName}
            maxLength={50}
          />
        ),
        type: FieldTypesEnum.PureDataField,
      },
      // { label: "Bravo Client Id", orderById: "BravoClientId", data: "BravoClientId", type: FieldTypesEnum.PureDataField, minWidth: "110px", },
      { label: 'Source', orderById: 'ThirdPartySource', data: 'ThirdPartySource', type: FieldTypesEnum.PureDataField },
      {
        label: 'Third-Party Survey Id',
        orderById: 'ThirdPartySurveyId',
        data: 'ThirdPartySurveyId',
        type: FieldTypesEnum.PureDataField,
      },
      { label: 'Invoiceable?', orderById: 'IsUninvoiceable', data: (item) => JsxHelper.YesNoReverse(item.IsUninvoiceable) },
      { label: 'Is Activated', orderById: 'IsActivated', data: (item) => JsxHelper.YesNo(item.IsActivated) },
      { label: 'Modified On', orderById: 'ModifiedOnUtc', data: 'ModifiedOnUtc', type: FieldTypesEnum.PureDataField },
      //   { label: 'Modified By', orderById: 'ModifiedBy', data: 'ModifiedByUserName', type: FieldTypesEnum.PureDataField },
      {
        label: 'Actions',
        orderById: '',
        data: TpSurveyItem.getActionsCellContent,
        type: FieldTypesEnum.ActionButton,
      },
    ];
  }

  // prettier-ignore
  static FieldsToShowInListTable = [
    {
      tabName: "General", tabLabel: "General", icon: "fa-solid fa-users",
      data: [
        { name: "TpSurveyId", label: "ID", className: "text-left" },
        { name: "ThirdPartySurveyName", label: "Name", className: "text-left" },
        { name: "ThirdPartySurveyId", label: "Third-Party Survey ID", className: "text-left" },
        { name: "ThirdPartySource", label: "Source", className: "text-left" },
        { name: "IsActivatedText", label: "Is Activated", className: "text-left" },
        { name: (item) => JsxHelper.YesNoReverse(item.IsUninvoiceable), label: "Invoiceable?", className: "text-left" },
        { name: "SurveyType", label: "Survey Type", className: "text-left" },
      ],
    },
  ];

  static getActionsCellContent (item)
  {
    return (
      <DataTableActionMenu
        options={[
          {
            text: item.IsActivated == true ? 'Deactivate Survey' : 'Activate Survey',
            onClick: () => TpSurveyItem.activateDeactivateFunction(item),
            iconName: item.IsActivated ? 'fa-solid fa-xmark' : 'fa-solid fa-check',
            roleKey: 'project_edit',
          },
          {
            iconName: 'fa-solid fa-edit',
            text: 'Remove Association',
            onClick: () => TpSurveyItem.removeAssociationFunction(item.CfId, item),
            roleKey: 'project_edit',
          },
        ]}
      />
    );
  }

  static removeAssociationFunction = (id, item, itemList) =>
  {
    alert('Empty function');
  };

  static activateDeactivateFunction (item)
  {
    if (item.IsActivated == true)
    {
      TpSurveyItem.deactivateSurveyFunction(item);
      return;
    }
    TpSurveyItem.activateSurveyFunction(item);
  }

  static activateSurveyFunction (item)
  {
    // ErrorMessage.SetApprove(
    //   <span>
    //     You will activate this third-party survey: {item.ThirdPartySurveyName} <br />
    //     Are you sure?
    //   </span>,
    //   () => this.clickOnActivateSurvey(item.TpClientLinkId)
    // );
    this.clickOnActivateSurvey(item);
  }

  static clickOnActivateSurvey = (item) =>
  {
    alert(`It is just a placeholder. Actual implementation will be done in the TpSurveyAdmin.js file.`);
  };

  static deactivateSurveyFunction = (item) =>
  {
    ErrorMessage.SetApprove(
      <span>
        You will deactivate this third-party survey: {item.ThirdPartySurveyName} <br />
        Are you sure?
      </span>,
      () => this.clickOnDeactivateSurvey(item)
    );
  };

  static clickOnDeactivateSurvey = (item) =>
  {
    alert(`It is just a placeholder. Actual implementation will be done in the TpSurveyAdmin.js file.`);
  };
}
